import { plugin, debug, type ButtonGroupProps } from 'light-component';
import { Radio } from 'antd';
import { Icons } from 'zf-web-components/icons';
import { t } from '../../i18n';
import styles from './style.module.less';
import type { IconNames } from 'zf-web-components/icons';
import type { ReactElement } from 'react';

export function WidgetButtonGroup(props: ButtonGroupProps): ReactElement {
  debug.widget('dashboard buttonGroup', props);
  if (props.mode === 'thumbnail') {
    return (
      <ThumbnailButtonGroup />
    );
  }
  return (
    <Radio.Group
      className={props.className}
      value={props.value}
      style={props.style}
      buttonStyle='solid'
      optionType='button'
      onChange={({ target }) => props.onChange?.(target.value)}
    >
      {(props.options ?? []).map(item => (
        <Radio.Button key={props.value}>
          <Icons name={props.name as IconNames} />
          {t(item.title)}
        </Radio.Button>
      ))}
    </Radio.Group>
  );
  function ThumbnailButtonGroup(): ReactElement {
    return (
      <div className={styles.control}>
        <Icons name='AppstoreAddOutlined' className={styles.icon} />
      </div>
    );
  }
}

plugin.register({ kind: 'widget', type: 'buttongroup', component: WidgetButtonGroup });
